import { env } from '@/env'
import { useToast } from '@/hooks/use-toast'
import Turnstile, { BoundTurnstileObject, useTurnstile } from 'react-turnstile'

export function TurnstileWidget({
  onVerify,
}: {
  onVerify: (token: string, boundTurnstile: BoundTurnstileObject) => void
}) {
  const turnstile = useTurnstile()
  const { toast } = useToast()

  return (
    <Turnstile
      sitekey={env.NEXT_PUBLIC_TURNSTILE_SITE_KEY}
      theme="light"
      size="flexible"
      className='w-full'
      
      onVerify={onVerify}
      onExpire={() => {
        turnstile.reset()
      }}
      onError={() => {
        toast({
          title: 'เกิดปัญหาระหว่างพยายามยืนยันตัวตน',
          description: 'รบกวนลองอีกครั้ง',
          variant: 'destructive',
        })
        turnstile.reset()
      }}
    />
  )
}
